import { useMutation } from '@tanstack/react-query';
import { ITitlePeriodProps } from './useGetTitlePeriod';
import { configApi } from '../../configApi';
import { FieldValues } from 'react-hook-form';

interface ISendPropsTitlePeriod {
  payload: FieldValues;
  stepId: string;
  registrationId: string;
  file: File;
  topicId: string;
}

const SendTitle = async (params: ISendPropsTitlePeriod) => {
  const formData = new FormData();

  formData.append('registration', params.registrationId);

  formData.append('step', params.stepId);

  formData.append('type', params.topicId);

  if (params.payload.declaration_value) {
    formData.append('declared_value', params.payload.declaration_value);
  }

  formData.append('observation', params.payload.observation);

  if (params.file) {
    formData.append(`attachments`, params.file);
  }

  const url = `candidate-area/titles/create/`;

  const response = await configApi.post<ITitlePeriodProps>(url, formData);

  return response.data;
};
export const useSendTitle = () => {
  return useMutation({
    mutationKey: ['send_title_period'],
    mutationFn: (data: ISendPropsTitlePeriod) => SendTitle(data),
  });
};
